import { useState, useEffect} from "react";
import { useSelector } from "react-redux";
import { T } from "react-translator-component";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { openPortal } from "../util/PortalAppFunction";

const MebukuIdUpgradeBanner  = () => {
  const { user } = useSelector((state: any) => state.userAuth)
  const [isShow, setIsShow] = useState<boolean>(false)

  useEffect(() => {
    setIsShow(user?.id_kind && user.id_kind !== '1')
  }, [user])

  return (
    <>
      {isShow && (
        <div style={{ marginTop: 30 }}>
          <Box
            onClick={() => openPortal()}
            sx={{
              display: "flex",
              position: "fixed",
              bottom: "0",
              right: "0",
              justifyContent: "flex-end",
              width: "100%",
              backgroundColor:'white',
              zIndex:9
            }}
          >
            <Tooltip
              placement="left"
              arrow
              open={true}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title={<Typography sx={{ color: "#000" }}>{T('upgrade_to_regular_account')}</Typography>}
              slotProps={{
                popper: {
                  disablePortal: true,
                },
              }}
              componentsProps={{
                tooltip: {
                  sx: {
                    border: "1px solid #70AD47",
                    bgcolor: "#C4E0B2",
                    "& .MuiTooltip-arrow": {
                      color: "#C4E0B2",
                      "&::before": {
                        border: "1px solid #70AD47", // Adds border to arrow
                      },
                    },
                  },
                },
              }}
            >
              <img alt={''} style={{ height: "40px", width: "40px", }} src={require("../assets/images/touch.png")} />
            </Tooltip>
          </Box>
        </div>
      )}
    </>
  )
};

export default MebukuIdUpgradeBanner;
